module.exports = __webpack_public_path__ + "static/media/tires.65ee14af.png";